import ReactModal from "react-modal";
import { useEffect, useState } from "react";
import { Icon } from "./icons/Icon";

interface ModalProps {
    title?: string | React.ReactNode;
    children?: React.ReactNode;
    onClose: () => void;
    style?: React.CSSProperties;
    variant?: "center" | "popup";
}

export const Modal = ({
    title,
    children,
    onClose,
    style,
    variant = "center",
}: ModalProps) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(true);
    }, []);

    return (
        <div
            className={`fixed ${
                variant === "center" ? "center-modal" : "popup-modal"
            }`}
        >
            <ReactModal
                isOpen={isOpen}
                ariaHideApp={false}
                onRequestClose={onClose}
                shouldCloseOnOverlayClick={false}
                style={{ content: { ...style } }}
            >
                <div className={`gap-4 flex flex-col pt-4`}>
                    <div
                        className={`flex justify-end absolute ${
                            variant === "center"
                                ? "top-2 left-2"
                                : "top-4 left-4"
                        }`}
                    >
                        <button onClick={onClose} className="w-6">
                            <Icon name="x" width={24} height={24} />
                        </button>
                    </div>
                    {title && <h2>{title}</h2>}
                    {children && children}
                </div>
            </ReactModal>
        </div>
    );
};
